(ns frontend.test.alerts
  (:require [frontend.routing :as routing]
            [frontend.bootstrap.components :as rbs]))

(defmethod routing/render-view :test/alerts [{:keys [route-params]}]
  (let []
    [:div.container.bg-white.scroll
     [:h1.title-h1.mb-4 "Alerts"]
     [rbs/Alert {:variant   "primary"
                 :bs-prefix ""} "A simple primary alert—check it out!"]
     [rbs/Alert {:variant   "secondary"
                 :bs-prefix ""} "A simple secondary alert—check it out!"]
     [rbs/Alert {:variant   "success"
                 :bs-prefix ""} "A simple success alert—check it out!"]
     [rbs/Alert {:variant   "danger"
                 :bs-prefix ""} "A simple danger alert—check it out!"]
     [rbs/Alert {:variant   "warning"
                 :bs-prefix ""} "A simple warning alert—check it out!"]
     [rbs/Alert {:variant   "info"
                 :bs-prefix ""} "A simple info alert—check it out!"]
     [rbs/Alert {:variant   "light"
                 :bs-prefix ""} "A simple light alert—check it out!"]
     [rbs/Alert {:variant   "dark"
                 :bs-prefix ""} "A simple dark alert—check it out!"]
     ]))
